import React, { useState, useEffect, useCallback, useRef, useMemo, useLayoutEffect } from 'react';
import { motion, AnimatePresence } from "framer-motion";
// import ToastPopup from "../../components/comm/ToastPopup";
import style from '../Chat.module.css';
// import ReactMarkdown from 'react-markdown';
import MarkdownText from '../../../../components/comm/MarkdownText';
import imgAvata from '../../../../images/common/img_chat_mascot.svg';

function AiMessage({chatVariants, chatInfo, searchKeyword, currentSearchMatch, chatIndex, searchResultRefs, handleTagClick, handleClickFeedback, queueStatus}) {
    const [isFull, setIsFull] = useState(false);
    const contentRef = useRef(null);

    const isTextOverLimit = (text) => text && text.length > 500;
    // const getTruncatedText = (text) => text.length > 500 ? text.substring(0, 500) + '...' : text;

    const likeAt = chatInfo.likeAt;
    const source = chatInfo.source;

    const [localLikeAt, setLocalLikeAt] = useState(likeAt ?? null);

    useEffect(() => {
        setLocalLikeAt(likeAt ?? null);
    }, [likeAt]);

    // const handleClickFeedbackPre = useCallback((feedback) => {
    //     if (localLikeAt !== null && localLikeAt !== undefined) {
    //         console.log("피드백 완료 건 : ", botChttMsgId);
    //         return;
    //     }

    //     handleClickFeedback(botChttMsgId, feedback, questionTime);
    //     setLocalLikeAt(feedback ? '1' : '0');
    // }, [localLikeAt, botChttMsgId, questionTime, handleClickFeedback]);


    return (
        <>
            <div className={style['ai-talk-box']}>
                <strong className={style['ai-avatar']}>
                    <img src={imgAvata} alt="ai 아바타" />
                </strong>

                <div className={style['ai-box']}>
                    <div className={style['text-box']}>
                        {/* <div className={style['p-group']}>
                            <p>
                                {chatInfo.text}
                                {chatInfo.isStreaming && (
                                    <span className={style["stream-cursor"]} />
                                )}
                            </p>
                        </div> */}

                        <div className={style['p-group']}>
                            {chatInfo.messageTitle && (
                                <strong>{chatInfo.messageTitle}</strong>
                            )}

                            <div className={style['markdown-content']}>
                                {/* <ReactMarkdown>
                                    {chatInfo.text || ''}
                                </ReactMarkdown>*/}
                                <MarkdownText text={chatInfo.text || ''} />

                                {chatInfo.isStreaming && (
                                    <span className={style["stream-cursor"]} />
                                )}
                            </div>
                        </div>
                        <span className={style['date-txt']}>{chatInfo.chatTime}</span>
                    </div>

{/* 
                    {chatInfo.tags && (
                        <div className={style['inform-box']} data-type="b">
                            <ul>
                                {chatInfo.tags.map((tag, i) => (
                                    <li
                                        key={`${chatInfo.id}-${tag}-${i}`}
                                        onClick={() => {
                                            if (!chatInfo.submitted) {
                                                handleTagClick(tag, chatInfo.id);
                                            }
                                        }}
                                    >
                                        {tag}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )} */}

                    {/* 테이블 안보임에 따른 테이블 추자 작업  */}
                    {(chatInfo.tables || []).map((table, tableIndex) => (
                        <div
                            key={tableIndex}
                            className={style["input-table-wrap"]}
                            style={{marginTop: 'var(--sp-12)'}}
                        >
                            {table.table_title && (
                                <strong>{table.table_title}</strong>
                            )}

                            <table className={style["input-table"]} data-table="ai-message">
                                <thead>
                                    <tr>
                                        <th>항목</th>
                                        <th>값</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {(table.rows || []).map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            <td>{row.column}</td>
                                            <td>{row.value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ))}

                    {/* 선택 완료 후 버튼을 아예 없애 */}
                    {chatInfo.tags && !chatInfo.submitted && (
                        <div className={style["inform-box"]} data-type="b">
                            <ul>
                                {chatInfo.tags.map((tag, i) => (
                                    <li
                                        key={`${chatInfo.id}-${tag}-${i}`}
                                        onClick={() => handleTagClick(tag, chatInfo.id)}
                                    >
                                        {tag}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* 선택 완료 후 다른버튼 비활성화 */}
                    {/* {chatInfo.tags && (
                        <div className={style["inform-box"]} data-type="b">
                            <ul>
                                {chatInfo.tags.map((tag, i) => {
                                    const isSelected = chatInfo.selectedValue === tag;

                                    return (
                                        <li
                                            key={`${chatInfo.id}-${tag}-${i}`}
                                            className={
                                                isSelected
                                                    ? style["selected"]
                                                    : undefined
                                            }
                                            aria-disabled={chatInfo.submitted}
                                            onClick={() => {
                                                if (!chatInfo.submitted) {
                                                    handleTagClick(tag, chatInfo.id);
                                                }
                                            }}
                                        >
                                            {tag}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )} */}
                </div>
            </div>
        </>
    );
}

export default React.memo(AiMessage);